<template>
  <div>
    <div
      id="view"
      class="map"
    />

    <!-- hopefully one day we can replace the HTML widgets with Vue components:  -->
    <!-- <div id="filter" class="esri-widget filter-by-dropdown">
      <FilterByDropdown
        id="project-select"
        ref="programFilter"
        filter-type="program"
      />
      <FilterByDropdown ref="projectFilter" filter-type="project" />
      <FilterByDropdown ref="surveyFilter" filter-type="survey" />
    </div> -->

    <div id="programs">
      <label for="program-select">
        <strong>Select Program:&nbsp;</strong>
      </label>
      <select id="program-select" />
    </div>

    <div id="projects">
      <label for="project-select">
        <strong>Select Project:&nbsp;</strong>
      </label>
      <select id="project-select" />
    </div>

    <div id="surveys">
      <label for="survey-select">
        <strong>Select Survey:&nbsp;</strong>
      </label>
      <select id="survey-select" />
    </div>

    <div
      id="clear-filters"
      class="esri-widget"
    >
      <button
        id="reset"
        type="button"
      >
        Clear filters
      </button>
    </div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { mapState, mapActions } from "vuex";
// import FilterByDropdown from "@/components/Dashboard/Charts/FilterByDropdown";

import {
  stakeholderLabels,
  surveyLabels,
  getMarkerSymbol
} from "@/mapConstants.ts";

export default {
  name: "Map",
  // components: {
  //   FilterByDropdown
  // },
  data() {
    return {
      baseUrl: "https://static.arcgis.com/images/Symbols/Firefly/",
      baseUrl2: "https://static.arcgis.com/images/Symbols/PeoplePlaces/",
      urls: {
        1: () => {
          return this.baseUrl + "FireflyC11.png";
        },
        2: () => {
          return this.baseUrl + "FireflyC16.png";
        },
        3: () => {
          return this.baseUrl + "FireflyC20.png";
        },
        stakeholder: () => {
          return this.baseUrl + "FireflyE4.png";
        },
        comment: () => {
          return this.baseUrl + "FireflyC2.png";
        },
        home: () => {
          return this.baseUrl2 + "Housing.png";
        },
        work: () => {
          return this.baseUrl2 + "Office.png";
        },
        meet: () => {
          return this.baseUrl2 + "Crowd.png";
        },
        play: () => {
          return this.baseUrl2 + "Sports.png";
        }
      },
      defaultMarkerSymbol: {
        type: "simple-marker",
        color: [255, 255, 255, 0],
        outline: {
          color: [0, 0, 0, 0]
        },
        width: 24,
        height: 24
      }
    };
  },
  methods: {
    ...mapActions({
      getResponses: "response/getResponses",
      addStakeholderResponses: "response/addStakeholderResponses",
      getPrograms: "programs/getPrograms",
      getProjects: "projects/getProjects",
      fetchSurveys: "survey/fetchSurveys",
      fetchStakeholders: "stakeholders/fetchStakeholders"
    }),
    getAllResponses() {
      this.getResponses();
    },
    getAllPrograms() {
      this.getPrograms();
    },
    getAllProjects() {
      this.getProjects();
    },
    getAllSurveys() {
      this.fetchSurveys();
    },
    loadMap() {
      /* eslint-disable */
      const options = {
        version: "4.12",
        css: true
      }; // explicitly set API version to avoid future breaking changes
      loadModules(
        [
          "esri/Map",
          "esri/Graphic",
          "esri/PopupTemplate",
          "esri/views/MapView",
          "esri/widgets/BasemapToggle",
          "esri/widgets/Home",
          "esri/widgets/LayerList",
          "esri/widgets/Print",
          "esri/widgets/Expand",
          "esri/layers/GraphicsLayer",
          "esri/layers/GroupLayer",
          "esri/core/watchUtils",
          "dojo/on"
        ],
        options
      )
        .then(
          ([
            Map,
            Graphic,
            PopupTemplate,
            MapView,
            BasemapToggle,
            Home,
            LayerList,
            Print,
            Expand,
            GraphicsLayer,
            GroupLayer,
            watchUtils,
            on
          ]) => {
            const addCommentWithType = (type, template, urlString, layer) => {
              const point = {
                type: "point",
                longitude: type.x,
                latitude: type.y
              };

              const pointGraphic = new Graphic({
                geometry: point,
                popupTemplate: template
              });

              const url = this.urls[urlString]();
              pointGraphic.symbol = getMarkerSymbol(url);

              layer.add(pointGraphic);
            };

            const addPointToCommentLayer = (favorability, pointGraphic) => {
              if (favorability === 1) {
                unfavorableResponseByCommentLocation.add(pointGraphic);
              } else if (favorability === 2) {
                neutralResponseByCommentLocation.add(pointGraphic);
              } else if (favorability === 3) {
                favorableResponseByCommentLocation.add(pointGraphic);
              } else {
                markerSymbol = this.defaultMarkerSymbol;
              }
            };
            const addPointToAddressLayer = (favorability, pointGraphic) => {
              if (favorability === 1) {
                unfavorableResponseByAddress.add(pointGraphic);
              } else if (favorability === 2) {
                neutralResponseByAddress.add(pointGraphic);
              } else if (favorability === 3) {
                favorableResponseByAddress.add(pointGraphic);
              } else {
                markerSymbol = this.defaultMarkerSymbol;
              }
            };

            // Build program selection options
            const createProgramSelect = () => {
              let programs = document.getElementById("programs");
              let programSelect = document.getElementById("program-select");
              let blankOption = document.createElement("option");
              blankOption.value = null;
              blankOption.text = "";
              programSelect.appendChild(blankOption);
              this.all_programs.forEach(program => {
                let option = document.createElement("option");
                option.value = program.pk;
                option.text = program.name;
                programSelect.appendChild(option);
              });
              programs.appendChild(programSelect);
            };

            // Build project selection options
            const createProjectSelect = (programId = -1) => {
              let projects = document.getElementById("projects");
              let projectSelect = document.getElementById("project-select");

              // Clear options
              projectSelect.disabled = false;
              while (projectSelect.firstChild) {
                projectSelect.removeChild(projectSelect.firstChild);
              }
              // Only show projects associated with program
              let filteredProjects = this.all_projects.filter(
                project => project.program == programId
              );

              if (filteredProjects.length == 0) {
                let option = document.createElement("option");
                projectSelect.disabled = true;
                option.selected = "selected";
                option.disabled = true;
                option.value = 0;
                option.text = "You must first choose a Program";
                projectSelect.appendChild(option);
              } else {
                let blankOption = document.createElement("option");
                blankOption.value = null;
                blankOption.text = "";
                projectSelect.appendChild(blankOption);
                filteredProjects.forEach(project => {
                  let option = document.createElement("option");
                  option.value = project.pk;
                  option.text = project.name;
                  projectSelect.appendChild(option);
                });
                projects.appendChild(projectSelect);
              }
            };

            // Build survey selection options
            const createSurveySelect = (projectId = -1) => {
              let surveys = document.getElementById("surveys");
              let surveySelect = document.getElementById("survey-select");
              // Clear options
              surveySelect.disabled = false;
              while (surveySelect.firstChild) {
                surveySelect.removeChild(surveySelect.firstChild);
              }
              // Only show surveys associated with project
              let filteredSurveys = this.all_surveys.filter(
                survey => survey.project == projectId
              );
              if (filteredSurveys.length == 0) {
                let option = document.createElement("option");
                surveySelect.disabled = true;
                option.selected = "selected";
                option.disabled = true;
                option.value = 0;
                option.text = "You must first choose a Project";
                surveySelect.appendChild(option);
              } else {
                let blankOption = document.createElement("option");
                blankOption.value = null;
                blankOption.text = "";
                surveySelect.appendChild(blankOption);
                filteredSurveys.forEach(survey => {
                  let option = document.createElement("option");
                  option.value = survey.pk;
                  option.text = survey.name;
                  surveySelect.appendChild(option);
                });
                surveys.appendChild(surveySelect);
              }
            };

            const addStakeholderLocationGraphicsToLayers = (
              stakeholders,
              responses
            ) => {
              // Creates graphics for symbolizing stakeholders by geocoded address
              // Clear graphics
              stakeholderLocations.removeAll();
              stakeholderLocations.refresh();
              stakeholders.forEach(stakeholder => {
                if (stakeholder.latitude != "") {
                  let point = {
                    type: "point",
                    longitude: stakeholder.longitude,
                    latitude: stakeholder.latitude
                  };
                  const url = this.urls["stakeholder"]();
                  let markerSymbol = getMarkerSymbol(url);

                  const filteredResponses = responses.filter(
                    response => response.survey_taker_id === stakeholder.pk
                  );

                  filteredResponses.forEach(response => {
                    let contentString = surveyLabels(response);

                    let template = new PopupTemplate({
                      title:
                        "<strong> Stakeholder - Location - Details </strong>",
                      content: stakeholderLabels(stakeholder) + contentString
                    });
                    let pointGraphic = new Graphic({
                      geometry: point,
                      symbol: markerSymbol,
                      popupTemplate: template
                    });
                    stakeholderLocations.add(pointGraphic);
                  });
                } else {
                  // TO-DO: handle stakeholders who don't have geoCode
                }
              });
            };

            const addFavorabilityCommentLocationGraphicsToLayers = (
              surveyResponses,
              survey = this.selectedSurvey.pk
            ) => {
              //Clear previous graphics
              favorableResponseByCommentLocation.removeAll();
              neutralResponseByCommentLocation.removeAll();
              unfavorableResponseByCommentLocation.removeAll();
              favorabilityByCommentLocationLayers.refresh();
              let filteredSurveyResponses;
              if (survey == -1) {
                // Show all survey responses by default
                filteredSurveyResponses = surveyResponses;
              } else {
                // TODO: need to account for different survey shapes and sizes
                filteredSurveyResponses = surveyResponses.filter(
                  r => r.survey == survey
                );
              }
              filteredSurveyResponses.forEach(surveyResponse => {
                if (
                  surveyResponse.comment_location != null &&
                  Object.entries(surveyResponse.comment_location).length != 0
                ) {
                  let point = {
                    type: "point",
                    longitude: surveyResponse.comment_location[1],
                    latitude: surveyResponse.comment_location[0]
                  };
                  let surveyTaker = this.stakeholders.filter(
                    stakeholder =>
                      stakeholder.pk == surveyResponse.survey_taker_id
                  )[0]; // index okay here? Assuming at least one item returned
                  let contentString = surveyLabels(surveyResponse);

                  let template = new PopupTemplate({
                    title: "<strong> Comment Details </strong>",
                    content: stakeholderLabels(surveyTaker) + contentString
                  });

                  let favorability =
                    surveyResponse.response_json.FavorabilityTowardsProject;

                  let pointGraphic = new Graphic({
                    geometry: point,
                    popupTemplate: template
                  });

                  if (favorability) {
                    const url = this.urls[favorability]();
                    let markerSymbol = getMarkerSymbol(url);
                    pointGraphic.symbol = markerSymbol;
                    addPointToCommentLayer(favorability, pointGraphic);
                  }
                }
              });
            };
            const addFavorabilityStakeholderLocationGraphicsToLayers = (
              stakeholders,
              survey = this.selectedSurvey.pk
            ) => {
              // Creates graphics for symbolizing Favorability by geocoded address
              // TO DO: Need to filter by survey responses to catch multiple responses, otherwise only mapping one-to-one response
              //Clear previous graphics
              favorableResponseByAddress.removeAll();
              neutralResponseByAddress.removeAll();
              unfavorableResponseByAddress.removeAll();
              favorabilityByAddressLayers.refresh();
              stakeholders.forEach(stakeholder => {
                if (stakeholder.latitude != "") {
                  let point = {
                    type: "point",
                    longitude: stakeholder.longitude,
                    latitude: stakeholder.latitude
                  };
                  // collect survey responses associated with survey taker, filter by survey number
                  let surveyResponses = this.all_responses
                    .filter(
                      surveyResponse =>
                        surveyResponse.survey_taker_id == stakeholder.pk
                    )
                    .filter(surveyResponse => surveyResponse.survey == survey); // need to be able to reference other surveys
                  surveyResponses.forEach(surveyResponse => {
                    let contentString = surveyLabels(surveyResponse);

                    let template = new PopupTemplate({
                      title:
                        "<strong> Stakeholder - Location - Details </strong>",
                      content: stakeholderLabels(stakeholder) + contentString
                    });

                    let favorability =
                      surveyResponse.response_json.FavorabilityTowardsProject;
                    let pointGraphic = new Graphic({
                      geometry: point,
                      popupTemplate: template
                    });

                    if (favorability) {
                      const url = this.urls[favorability]();
                      let markerSymbol = getMarkerSymbol(url);
                      pointGraphic.symbol = markerSymbol;
                      addPointToAddressLayer(favorability, pointGraphic);
                    }
                  });
                } else {
                  // TO-DO: handle stakeholders who don't have geoCode
                }
              });
            };

            const addCommentLocationGraphicsToLayers = responses => {
              // Creates graphics for adding comment locations
              //Clear previous graphics

              homeLayer.removeAll();
              workLayer.removeAll();
              meetLayer.removeAll();
              playLayer.removeAll();
              pointOfInterestLayer.removeAll();

              commentLocations.refresh();

              responses.forEach(surveyResponse => {
                let point;

                if (
                  surveyResponse.comment_location != null &&
                  Object.entries(surveyResponse.comment_location).length != 0
                ) {
                  let surveyTaker = this.stakeholders.filter(
                    stakeholder =>
                      stakeholder.pk == surveyResponse.survey_taker_id
                  )[0]; // index okay here? Assuming at least one item returned

                  let contentString = surveyLabels(surveyResponse);

                  let template = new PopupTemplate({
                    title: "<strong> Comment Details </strong>",
                    content: stakeholderLabels(surveyTaker) + contentString
                  });

                  let point = {
                    type: "point",
                    longitude: null,
                    latitude: null
                  };

                  let pointGraphic = new Graphic({
                    geometry: null,
                    popupTemplate: template
                  });

                  // if comment is POI (no type)
                  // the following could be moved to a separate function like `addCommentWithType()` but meh
                  if (typeof surveyResponse.comment_location[0] === "number") {
                    point.longitude = surveyResponse.comment_location[1];
                    point.latitude = surveyResponse.comment_location[0];

                    const url = this.urls["comment"]();
                    pointGraphic.symbol = getMarkerSymbol(url);
                    pointGraphic.geometry = point;

                    pointOfInterestLayer.add(pointGraphic);
                  }

                  // else if comment has type
                  else {
                    const homePoint = surveyResponse.comment_location.find(
                      loc => loc.type === "home"
                    );
                    const workPoint = surveyResponse.comment_location.find(
                      loc => loc.type === "work"
                    );
                    const meetPoint = surveyResponse.comment_location.find(
                      loc => loc.type === "meet"
                    );
                    const playPoint = surveyResponse.comment_location.find(
                      loc => loc.type === "play"
                    );

                    if (homePoint) {
                      addCommentWithType(homePoint, template, `home`, homeLayer);
                    }

                    if (workPoint) {
                      addCommentWithType(workPoint, template, `work`, workLayer);
                    }

                    if (meetPoint) {
                      addCommentWithType(meetPoint, template, `meet`, meetLayer);
                    }

                    if (playPoint) {
                      addCommentWithType(playPoint, template, `play`, playLayer);
                    }
                  }
                }
              });
            };

            const map = new Map({
              basemap: "streets-vector"
            });
            const view = new MapView({
              map: map,
              container: "view",
              center: [-86.121095, 30.496713],
              zoom: 10,
              ui: {
                components: ["attribution"]
              }
            });
            const button = new Home({
              view: view
            });
            const layerlist = new LayerList({
              view: view
            });
            const basemap_toggle = new BasemapToggle({
              view: view,
              nextBasemap: "satellite"
            });
            const print = new Print({
              view: view,
              printServiceUrl:
                "https://gis.hntbatl.com/server/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task"
            });
            const filterExpand = new Expand({
              expandIconClass: "esri-icon-layer-list",
              view: view,
              content: layerlist
            });
            const exportExpand = new Expand({
              expandIconClass: "esri-icon-printer",
              view: view,
              content: print
            });

            view.ui.add("programs", "top-left");
            view.ui.add("projects", "top-left");
            view.ui.add("surveys", "top-left");
            view.ui.add("clear-filters", "top-left");
            // view.ui.add("filter", "top-left"); // this will be for adding the div containing the Vue component version of the filters
            view.ui.add(button, "top-left");
            view.ui.add(basemap_toggle, "bottom-left");
            if (this.$vuetify.breakpoint.xs) {
              view.ui.add([filterExpand, exportExpand], "top-right");
            } else {
              view.ui.add(layerlist, "top-right");
              view.ui.add(print, "top-right");
            }
            const stakeholderLocations = new GraphicsLayer({
              title: "Stakeholder Locations",
              visible: false
            });
            const homeLayer = new GraphicsLayer({
              title: "Home"
            });
            const workLayer = new GraphicsLayer({
              title: "Work"
            });
            const meetLayer = new GraphicsLayer({
              title: "Meet"
            });
            const playLayer = new GraphicsLayer({
              title: "Play"
            });
            const pointOfInterestLayer = new GraphicsLayer({
              title: "General POI"
            });
            const commentLocations = new GroupLayer({
              title: "Comment Responses",
              layers: [homeLayer, workLayer, meetLayer, playLayer, pointOfInterestLayer],
              visible: false
            });
            const favorableResponseByAddress = new GraphicsLayer({
              title: "In Favor"
            });
            const neutralResponseByAddress = new GraphicsLayer({
              title: "Neutral"
            });
            const unfavorableResponseByAddress = new GraphicsLayer({
              title: "Not In Favor"
            });
            const favorableResponseByCommentLocation = new GraphicsLayer({
              title: "In Favor"
            });
            const neutralResponseByCommentLocation = new GraphicsLayer({
              title: "Neutral"
            });
            const unfavorableResponseByCommentLocation = new GraphicsLayer({
              title: "Not In Favor"
            });
            const favorabilityByAddressLayers = new GroupLayer({
              title: "Favorability by Address",
              layers: [
                unfavorableResponseByAddress,
                neutralResponseByAddress,
                favorableResponseByAddress
              ],
              visible: false
            });
            const favorabilityByCommentLocationLayers = new GroupLayer({
              title: "Favorability by Comment Location",
              layers: [
                unfavorableResponseByCommentLocation,
                neutralResponseByCommentLocation,
                favorableResponseByCommentLocation
              ],
              visible: false
            });
            map.add(stakeholderLocations);
            map.add(commentLocations);
            map.add(favorabilityByAddressLayers);
            map.add(favorabilityByCommentLocationLayers);

            const programSelect = document.getElementById("program-select");
            const projectSelect = document.getElementById("project-select");
            const surveySelect = document.getElementById("survey-select");

            createProgramSelect();
            createProjectSelect(programSelect.value);
            createSurveySelect(projectSelect.value); // pass initial projectId on creation

            // leaving the following commented because i don't think we should load any points in graphics until at least "program" filter has been selected
            // addStakeholderLocationGraphicsToLayers(
            //   this.stakeholders,
            //   this.all_responses
            // );
            // addCommentLocationGraphicsToLayers(this.all_responses);
            // addFavorabilityStakeholderLocationGraphicsToLayers(
            //   this.stakeholders
            // );
            // addFavorabilityCommentLocationGraphicsToLayers(this.all_responses);

            // Events
            let programName = "";
            let projectName = "";
            let surveyName = "";

            const reset = () => {
              clearFilters();
              clearMap();
              refreshMap();
            };

            const clearFilters = () => {
              programName = "";
              programSelect.selectedIndex = 0;
              projectName = "";
              projectSelect.selectedIndex = 0;
              surveyName = "";
              surveySelect.selectedIndex = 0;
            };
            const clearMap = () => {

              homeLayer.removeAll();
              workLayer.removeAll();
              meetLayer.removeAll();
              playLayer.removeAll();
              pointOfInterestLayer.removeAll();

              stakeholderLocations.removeAll();
              favorableResponseByAddress.removeAll();
              favorableResponseByCommentLocation.removeAll();
            };

            const refreshMap = () => {
              commentLocations.refresh();
              stakeholderLocations.refresh();
              favorableResponseByAddress.refresh();
              favorableResponseByCommentLocation.refresh();
            };
            document.getElementById("reset").onclick = reset;

            on(programSelect, "change", evt => {
              const programId = evt.target.value;

              projectName = "";
              surveyName = "";
              projectSelect.selectedIndex = 0;
              surveySelect.selectedIndex = 0;

              createProjectSelect(programId);

              programName = this.all_programs.find(
                program => program.pk === Number(programId)
              ).name;

              const { stakeholders, responses } = this.multiFilter(
                programName,
                projectName,
                surveyName,
                this.all_responses
              );

              addCommentLocationGraphicsToLayers(responses);
              addStakeholderLocationGraphicsToLayers(stakeholders, responses);
            });

            on(projectSelect, "change", evt => {
              const projectId = evt.target.value;

              surveyName = "";
              surveySelect.selectedIndex = 0;

              createSurveySelect(projectId);

              projectName = this.all_projects.find(
                project => project.pk === Number(projectId)
              ).name;

              const { stakeholders, responses } = this.multiFilter(
                programName,
                projectName,
                surveyName,
                this.all_responses
              );

              addCommentLocationGraphicsToLayers(responses);
              addStakeholderLocationGraphicsToLayers(stakeholders, responses);
            });

            on(surveySelect, "change", evt => {
              const surveyId = evt.target.value;

              surveyName = this.all_surveys.find(
                survey => survey.pk === Number(surveyId)
              ).name;

              const { stakeholders, responses } = this.multiFilter(
                programName,
                projectName,
                surveyName,
                this.all_responses
              );

              addCommentLocationGraphicsToLayers(responses);
              addStakeholderLocationGraphicsToLayers(stakeholders, responses);

              addFavorabilityCommentLocationGraphicsToLayers(
                this.all_responses,
                surveySelect.value
              );
              addFavorabilityStakeholderLocationGraphicsToLayers(
                this.stakeholders,
                surveySelect.value
              );
            });
          }
        )
        .catch(err => {
          // handle any script or module loading errors
          console.error(err);
        });
    },
    getStakeholder(stakeholders, response) {
      return stakeholders.find(
        stakeholder => stakeholder.pk === response.survey_taker_id
      );
    },
    multiFilter(program, project, survey, responses) {
      const byProgram = r =>
        r.survey_metadata.meta_data.dashboardFiltering.program === program;
      const byProject = r =>
        r.survey_metadata.meta_data.dashboardFiltering.project === project;
      const bySurvey = r =>
        r.survey_metadata.meta_data.dashboardFiltering.survey === survey;

      const filters = [];
      if (program) {
        filters.push(byProgram);
      }
      if (project) {
        filters.push(byProject);
      }
      if (survey) {
        filters.push(bySurvey);
      }

      const results = filters.reduce(
        (data, filter) => data.filter(filter),
        responses
      );
      const stakeholders = results.map(r =>
        this.getStakeholder(this.stakeholders, r)
      );
      const distinctStakeholders = [...new Set(stakeholders)];

      return { stakeholders: distinctStakeholders, responses: results };
    }
  },
  computed: {
    ...mapState({
      all_responses: state => state.response.responses,
      all_programs: state => state.programs.programs,
      all_projects: state => state.projects.projects,
      all_surveys: state => state.survey.surveys,
      selectedProgram: state => state.programs.selectedProgram || "",
      selectedProject: state => state.projects.selectedProject || "",
      selectedSurvey: state => state.survey.selectedSurvey || "",
      stakeholders: state => state.stakeholders.stakeholders
    })
  },
  beforeMount() {
    this.getAllResponses();
    this.getAllPrograms();
    this.getAllProjects();
    this.fetchSurveys();
    this.fetchStakeholders();
    this.loadMap();
  }
};
</script>
<style>
.map {
  height: 94vh;
}
#programs,
#projects,
#surveys {
  padding: 12px;
  background-color: rgba(245, 245, 245, 1);
}
#program-select,
#project-select,
#survey-select {
  padding-left: 12px;
  padding-right: 12px;
  background-color: rgba(255, 255, 255, 1);
}
#reset {
  font-size: 14px;
  padding: 10px;
  font-weight: bold;
}
@media (min-width: 320px) and (max-width: 1023px) {
  #programs,
  #projects,
  #surveys {
    width: 80%;
  }
  #program-select,
  #project-select,
  #survey-select {
    width: 100%;
  }
}
</style>
